import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import { closed } from "../../components/drawer/drawerSlice";
import { EDIT_TYPE, INSERT_TYPE, STATUSARRAY } from "../../_contstants/common";
import {
  createLeadStatus,
  getAllLeadStatus,
  getLeadStatusById,
  updateLeadStatus,
} from "./services/leadStatus.services";
import { clearLeadStatusDetails } from "./leadStatusSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";

const CreateLeadStatus: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const LeadStatusDetail = useAppSelector(
    (state) => state.leadStatus.LeadStatusDetail
  );
  const LeadStatusGUID = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector((state) => state.leadStatus.formLoading);

  useEffect(() => {
    return () => {
      dispatch(clearLeadStatusDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (LeadStatusGUID) {
      dispatch(getLeadStatusById(LeadStatusGUID));
    }
  }, [LeadStatusGUID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!LeadStatusGUID) {
        const insertPayload = {
          LeadStatus: values?.LeadStatus ? values?.LeadStatus : "",
          IsActive: values?.IsActive === 1,
          OperationType: INSERT_TYPE,
        };
        const response = await dispatch(createLeadStatus(insertPayload));
        if (response?.payload?.Status === 201) {
          dispatch(closed());
          dispatch(clearLeadStatusDetails());
          dispatch(getAllLeadStatus());
        }
      } else {
        const editPayload = {
          LeadStatusGUID: LeadStatusGUID,
          LeadStatus: values?.LeadStatus ? values?.LeadStatus : "",
          IsActive: values?.IsActive === 1,
          OperationType: EDIT_TYPE,
        };
        const response = await dispatch(updateLeadStatus(editPayload));
        if (response?.payload?.Status === 200) {
          dispatch(closed());
          dispatch(clearLeadStatusDetails());
          dispatch(getAllLeadStatus());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={LeadStatusDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem className="drawer-header">
              <Typography.h4 className="m-0">
                {LeadStatusGUID ? "Update Lead Status" : "Create Lead Status"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="LeadStatus"
                label="Lead Status"
                placeholder="Lead Status"
                component={FormTextField}
                validator={requiredValidator} astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"IsActive"}
                name={"IsActive"}
                label={"Status"}
                placeholder="Status"
                component={FormSelectionField}
                validator={requiredValidator} astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              style={{
                marginTop: 20,
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={LeadStatusGUID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateLeadStatus;
